import { CourseModel } from '@descomplica/dex-models';
import { UNDERGRADUATE_CATEGORY_SLUG } from './category';

const redirectIfIsUndergrad = (course: CourseModel): boolean => {
  if (course.descomplicaCategorySlug === UNDERGRADUATE_CATEGORY_SLUG) {
    window.location.replace(
      `${process.env.BASE_URL}${UNDERGRADUATE_CATEGORY_SLUG}/${course.slug}/`,
    );

    return true;
  }
  return false;
};

export default redirectIfIsUndergrad;
